import { Select } from "antd";
import { Formik, Form, Field } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import FieldErrorMessage from "@/Components/common/FieldErrorMessage";
import { RequiredSymbol } from "@/Components/common/RequiredSymbol";
import { EyeIcon } from "@/Components/Icons/EyeIcon";
import { EyeSlashIcon } from "@/Components/Icons/EyeSlashIcon";
import { SelectDownIcon } from "@/Components/Icons/SelectDownIcon";
import { routingConstants } from "@/Constants/routingConstants";
import {
  toggleAccountVerificationModal,
  toggleEmailVerificationModal,
  toggleLoginBranchesModal,
  updateAccountVerificationFrom,
  updateEmailVerifyData,
  updateLoginAccessData,
  updateShowBoxes,
  updateNewUser,
} from "@/reducers/auth";
import { _login, _set_new_password, _validate_email } from "@/services/auth";
import {
  handleAPICatch,
  showErrorToast,
  showSuccessToast,
} from "@/utilities/utils";
import { validateEmail, validatePassword } from "@/validations/auth/login";

import { _localRemove } from "../../../localStorage";
import { setSession, setUser } from "../../../reducers/session";
import AuthButton from "../AuthButton";
import LoginFormTopContent from "../LoginFormTopContent";

// import { Head, router } from "@inertiajs/react";

/**
  ***** Handles the form submission for the login form. *****
  
  * userTypes => check which type of user is logged in.
  * hasPassword => 0 means new not register user or 1 means old register user 
  * userTypes => check which type of user is logged in.
  * isEmailValidated => true means only password field visible for old user and false means     password and new passsword field visible for new user
  * userId =>  user id of the logged in user
 */
const LoginForm = ({ setAuthEmail }) => {
  const { user_token } = useSelector((state) => state.session);
  const { loginAccessData, emailVerifyData } = useSelector(
    (state) => state.auth,
  );
  const {
    userId,
    userTypes,
    isEmailValidated,
    hasPassword,
    has_agencies,
    agencies,
    selectedAgencyUserId,
  } = emailVerifyData;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //For password show and hide
  const [passwordType, setPasswordType] = useState("password");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // isSubmitting =  to prevent multiple form submission
  const [isSubmitting, setIsSubmitting] = useState(false);
  // isAuthenticated =  to prevent multiple form submission and if login success so 1 time api called
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // useEffect(() => {
  //   if (loginAccessData.branchAccessIds.length > 0) {
  //     const firstBranch = loginAccessData.branchAccessIds[0];
  //     dispatch(updateLoginAccessData({
  //       ...loginAccessData,
  //       selectbranchAccessIds: firstBranch.client_id,
  //       isAccess: firstBranch.is_access
  //     }));
  //   }
  // }, [loginAccessData.branchAccessIds, dispatch]);

  const handleEmailVerification = (user) => {
    if (user.user_type === "client" && "include_in_mailshot" in user) {
      dispatch(
        updateNewUser({
          id: user.id,
          type: user.user_type,
          include_in_mailshot: user.include_in_mailshot,
        }),
      );
      dispatch(updateAccountVerificationFrom("login"));
      dispatch(toggleAccountVerificationModal(true));
    } else {
      dispatch(updateNewUser({ id: user.id, type: user.user_type }));
      dispatch(toggleEmailVerificationModal(true));
    }
  };

  const handleLoginSuccess = (user) => {
    if (user.is_confirm === 1) {
      if (user.user_type == "Candidate") {
        if (user.profile_percent.profile < 100) {
          window.location = $("#candidate_edit_profile").data("url");
        } else {
          window.location = $("#candidate_dashboard").data("url");
        }
      } else if (user.user_type == "Client") {
        setIsAuthenticated(true);
        // Navigate(getOTPUrl(user.otp_verification_url));
        // router.visit(user.otp_verification_url);
        // navigate(`/otp_verification/${user.id}/${user.email}`)
        navigate(routingConstants.otpVerification(user.id, user.email));
      } else if (user.user_type == "Client_User") {
        //again testing for if selected branch is null then open modal for select one branch else user selected one branch to login as so open otp verification.
        dispatch(
          setSession({
            user_id: user.id,
            user_type: user.user_type,
          }),
        );
        dispatch(setUser(user));
        // console.log(loginAccessData,emailVerifyData)
        //if user is client user then check if client has any branch access then open modal for select one branch else user selected one branch to login as so open otp verification.
        // if (
        //   loginAccessData.branchAccessIds.length > 0 &&
        //   loginAccessData.selectbranchAccessIds === null &&
        //   emailVerifyData.has_branch
        // ) {
        //   dispatch(toggleLoginBranchesModal(true));
        // } else {
        //   dispatch(
        //     updateLoginAccessData({
        //       email: null,
        //       password: null,
        //       branchAccessIds: [],
        //       selectbranchAccessIds: null,
        //     }),
        //   );
        dispatch(toggleLoginBranchesModal(false));
        //   // navigate(`/otp_verification/${user.id}/${user.email}`)
        setIsAuthenticated(true);
        navigate(routingConstants.otpVerification(user.id, user.email));
        setTimeout(() => {
          dispatch(
            updateLoginAccessData({
              email: null,
              password: null,
              branchAccessIds: [],
              selectbranchAccessIds: null,
              isAccess: 0,
            }),
          );
          dispatch(
            updateEmailVerifyData({
              isEmailValidated: false,
            }),
          );
          _localRemove("userauth");
        }, 500);
        //   // console.log(user.otp_verification_url)
        // router.visit(user.otp_verification_url);
        // }
      } else if (user.user_type == "Agency") {
        dispatch(
          setSession({
            user_id: user.id,
            user_type: user.user_type,
          }),
        );
        dispatch(setUser(user));
        setIsAuthenticated(true);
        navigate(routingConstants.otpVerification(user.id, user.email));
      } else {
        // router.visit(routingConstants.login);
        navigate(routingConstants.login);
      }
    } else {
      handleEmailVerification(user);
    }
  };

  const handleFormSubmit = (values, setSubmitting) => {
    if (isSubmitting || isAuthenticated) {
      return;
    }
    setIsSubmitting(true);
    setSubmitting(true);
    // Step 1: Validate Email
    if (!isEmailValidated) {
      _validate_email({ email: loginAccessData.email })
        .then((res) => {
          const {
            data: {
              isPassFound,
              user_id,
              type,
              branches,
              has_branch,
              has_agencies,
              agencies,
            },
          } = res;

          dispatch(
            updateEmailVerifyData({
              userId: user_id,
              userTypes: type,
              isEmailValidated: true,
              hasPassword: isPassFound ?? false,
              has_branch: has_branch,
              has_agencies: has_agencies ?? 0,
              agencies: agencies ?? [],
              selectedAgencyUserId: null,
            }),
          );
          dispatch(updateLoginAccessData({ branchAccessIds: [] }));
        })
        .catch((error) => {
          // console.log(error);
          dispatch(
            updateEmailVerifyData({
              isEmailValidated: false,
            }),
          );
          // setIsEmailValidated(false);
          handleAPICatch(error);
        })
        .finally(() => {
          setSubmitting(false);
          setIsSubmitting(false);
        });
    }
    // Guard: multi-agency but no agency selected yet
    else if (has_agencies == 1 && !selectedAgencyUserId) {
      showErrorToast("Please select an agency to continue.");
      setSubmitting(false);
      setIsSubmitting(false);
    }
    // Step 2: for old user Login- if user has verified email and password.
    else if (hasPassword) {
      //if user is client_user then check if client has any branch access then open modal for select one branch else user selected one branch to login-as so open otp verification.

      _login({
        email: loginAccessData?.email,
        password: loginAccessData?.password,
        login_branch_id: [],
        is_access: 1,
        has_branch: emailVerifyData?.has_branch,
        ...(selectedAgencyUserId && {
          agency_id: agencies?.find((a) => a.user_id === selectedAgencyUserId)
            ?.agency_id,
        }),
      })
        .then((res) => {
          const {
            status: resStatus,
            data: {
              user,
              token: { token },
            },
          } = res;
          if (resStatus === 200) {
            dispatch(
              setSession({
                user_token: token,
              }),
            );
            //check which type of user is logged in - as of now only client user is there if in future more user type will be added then add here.
            handleLoginSuccess(user);
          }
        })
        .catch((error) => {
          // console.log(error);
          handleAPICatch(error);
        })
        .finally(() => {
          setSubmitting(false);
          setIsSubmitting(false);
          setTimeout(() => {
            setIsAuthenticated(false);
          }, 7000);
        });
    } else {
      // Step 3: Set New Password for new user.
      _set_new_password({
        new_password: values.password,
        password_action: "Set Password",
        set_password_id: userId,
        set_new_password_type: userTypes,
      })
        .then((res) => {
          const {
            data: { message },
          } = res;
          // Transition to password-login flow without page reload.
          // Mark the user as now having a password so the login form shows
          // the standard password field instead of the "set new password" fields.
          dispatch(
            updateEmailVerifyData({
              hasPassword: true,
            }),
          );
          // Clear password from login access data so user must enter it fresh.
          dispatch(
            updateLoginAccessData({
              ...loginAccessData,
              password: null,
            }),
          );
          // Reset form password fields.
          values.password = "";
          values.confirm_password = "";
          showSuccessToast(
            message ||
              "Password set successfully. Please sign in with your new password.",
          );
        })
        .catch((error) => {
          handleAPICatch(error);
        })
        .finally(() => {
          setSubmitting(false);
          setIsSubmitting(false);
        });
    }
  };

  return (
    <div className="auth_form_wrapper">
      {/* <Head title="Login" /> */}
      <Formik
        initialValues={{
          email: loginAccessData?.email || "",
          password: "",
          branchAccessIds: "",
          confirm_password: "",
          selectedBranches: null,
        }}
        validateOnChange={false}
        validateOnBlur={false}
        validateOnMount={false}
        enableReinitialize={true}
        validate={(value) => {
          const errors = {};
          // if (loginAccessData.branchAccessIds.length > 0 && emailVerifyData.has_branch) {
          //   if (!loginAccessData?.selectbranchAccessIds) {
          //     errors.selectedBranches = 'Site is required';
          //   }
          // }
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          handleFormSubmit(values, setSubmitting);
        }}
      >
        {({
          submitForm,
          isSubmitting,
          errors,
          touched,
          isValid,
          setSubmitting,
          validateForm,
          values,
          validateField,
          setFieldValue,
        }) => (
          <Form className="flex flex-col gap-6">
            <LoginFormTopContent
              title="Sign In to your Account"
              desc="With advanced security, all details are completely secure and safe on our system."
            />
            {/* Open Login Sub Branches Modal */}
            {/* <LoginSubBranchesModal
              submitForm={submitForm}
              setFieldValue={setFieldValue}
              isSubmitting={isSubmitting}
              disabled={isSubmitting}
            /> */}
            <div>
              <div className="grid">
                <div className="flex flex-col gap-3">
                  <label htmlFor="email" className="label">
                    Email <RequiredSymbol />
                  </label>
                  <div>
                    <Field
                      autoFocus={true}
                      type="email"
                      className={`h-[40px] w-full rounded-lg border border-bodyText bg-none text-[14px] text-black shadow-none placeholder:text-[14px] placeholder:font-medium placeholder:text-txtColor autofill:bg-none autofill:shadow-none focus:border focus:border-primary focus:shadow-none focus:ring-0 ${
                        errors.email && touched.email ? "!border-red-500" : ""
                      }`}
                      autoComplete="off"
                      name="email"
                      // disabled={isSubmitting}
                      placeholder="Email Address"
                      validate={(value) => validateEmail(value)}
                      onChange={(e) => {
                        setFieldValue("email", e.target.value);
                        dispatch(
                          updateLoginAccessData({
                            ...loginAccessData,
                            email: e.target.value,
                          }),
                        );
                        if (isEmailValidated === true) {
                          dispatch(
                            updateEmailVerifyData({
                              isEmailValidated: false,
                            }),
                          );
                          // setIsEmailValidated(false);
                          setFieldValue("email", "");
                          setFieldValue("password", null);
                          setFieldValue("branchAccessIds", null);
                          setFieldValue("selectbranchAccessIds", null);
                          dispatch(
                            updateLoginAccessData({
                              ...loginAccessData,
                              email: "",
                              password: null,
                              branchAccessIds: [],
                              selectbranchAccessIds: null,
                            }),
                          );
                        }
                      }}
                      onKeyUp={(e) => {
                        setAuthEmail(e.target.value);
                        if (touched.email && errors.email) {
                          validateForm();
                        }
                        if (e.keyCode === 13) {
                          submitForm();
                          // if (document.activeElement != document.body) document.activeElement.blur();
                        }
                      }}
                    />
                    <FieldErrorMessage name="email" />
                  </div>
                </div>
                {isEmailValidated ? (
                  <>
                    {/* Agency selection dropdown for users belonging to multiple agencies */}
                    {has_agencies == 1 && (
                      <div className="mt-4 flex flex-col gap-2">
                        <label className="label">
                          Select Agency <RequiredSymbol />
                        </label>
                        <div>
                          <Select
                            showSearch
                            name="selectedAgency"
                            style={{ width: "100%" }}
                            placeholder="Select Agency"
                            optionFilterProp="children"
                            className="ease mt-1 min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey py-[0.13rem] !text-[14px] font-medium capitalize leading-[normal] text-black transition-all duration-200 focus:border-primary"
                            suffixIcon={
                              <SelectDownIcon cls={"text-txtColor"} />
                            }
                            value={selectedAgencyUserId}
                            onChange={(value) => {
                              const selected = agencies.find(
                                (a) => a.user_id === value,
                              );
                              dispatch(
                                updateEmailVerifyData({
                                  selectedAgencyUserId: value,
                                  userId: value,
                                  hasPassword: selected?.isPassFound ?? false,
                                }),
                              );
                            }}
                          >
                            {agencies.map((agency) => (
                              <Select.Option
                                value={agency.user_id}
                                key={agency.agency_id}
                                className="text-[14px] capitalize"
                              >
                                {agency.agency_name}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    )}

                    {/* Show password / new-password fields once agency is resolved */}
                    {(has_agencies == 0 || selectedAgencyUserId != null) && (
                      <>
                        {hasPassword ? (
                          <>
                            {loginAccessData.branchAccessIds.length > 0 &&
                            emailVerifyData.has_branch ? (
                              <>
                                <div className="mt-4 flex flex-col gap-2">
                                  <label htmlFor="email" className="label">
                                    Site <RequiredSymbol />
                                  </label>
                                  <div>
                                    <Select
                                      showSearch
                                      name="selectedBranches"
                                      style={{ width: "100%" }}
                                      placeholder="Select site"
                                      optionFilterProp="children"
                                      className={`ease mt-1 min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey py-[0.13rem] !text-[14px] font-medium capitalize leading-[normal] text-black transition-all duration-200 focus:border-primary ${
                                        errors.selectedBranches &&
                                        touched.selectedBranches
                                          ? "!border-red-500"
                                          : ""
                                      }`}
                                      suffixIcon={
                                        <SelectDownIcon cls={"text-txtColor"} />
                                      }
                                      value={
                                        values.selectedBranches
                                          ? values.selectedBranches
                                          : loginAccessData?.branchAccessIds[0]
                                              ?.client_id
                                      }
                                      onChange={async (value, type) => {
                                        setFieldValue(
                                          "selectedBranches",
                                          value,
                                        );
                                        await Promise.resolve();
                                        if (
                                          touched.selectedBranches &&
                                          errors.selectedBranches
                                        ) {
                                          validateForm();
                                        }
                                        let isAccess =
                                          loginAccessData.branchAccessIds.find(
                                            (item) => item?.client_id === value,
                                          )?.is_access;

                                        dispatch(
                                          updateLoginAccessData({
                                            selectbranchAccessIds: value,
                                            isAccess: isAccess,
                                          }),
                                        );
                                      }}
                                      onKeyUp={(e) => {
                                        if (e.keyCode === 13) {
                                          submitForm();
                                          // if (document.activeElement != document.body) document.activeElement.blur();
                                        }
                                      }}
                                    >
                                      {loginAccessData.branchAccessIds.map(
                                        (item) => {
                                          const {
                                            client_id,
                                            client_name,
                                            is_access,
                                          } = item;
                                          return (
                                            <Select.Option
                                              value={client_id}
                                              key={client_id}
                                              className="text-[14px] capitalize"
                                            >
                                              {client_name}
                                            </Select.Option>
                                          );
                                        },
                                      )}
                                    </Select>
                                  </div>
                                </div>
                                <FieldErrorMessage
                                  name="selectedBranches"
                                  className={"text-red"}
                                />
                              </>
                            ) : null}
                            {/* For checking branches field */}

                            {/* For password filed */}
                            <div className="mt-4 flex flex-col gap-3">
                              <label
                                htmlFor="password"
                                className="label !text-[14px]"
                              >
                                Password <RequiredSymbol />
                              </label>
                              <div>
                                <div className="relative">
                                  <Field
                                    type={showPassword ? "text" : "password"}
                                    className={`h-[40px] w-full rounded-lg border border-bodyText bg-none text-[14px] text-black shadow-none placeholder:text-[14px] placeholder:font-medium placeholder:text-txtColor autofill:bg-none autofill:shadow-none focus:border focus:border-primary focus:shadow-none focus:ring-0 ${
                                      errors.password && touched.password
                                        ? "!border-red-500"
                                        : ""
                                    }`}
                                    autoComplete="current-password"
                                    name="password"
                                    placeholder="Password"
                                    validate={(value) =>
                                      validatePassword(value)
                                    }
                                    onChange={(e) => {
                                      setFieldValue("password", e.target.value);
                                      dispatch(
                                        updateLoginAccessData({
                                          ...loginAccessData,
                                          password: e.target.value,
                                        }),
                                      );
                                    }}
                                    onKeyUp={(e) => {
                                      if (touched.password && errors.password) {
                                        validateForm();
                                      }
                                      if (e.keyCode === 13) {
                                        submitForm();
                                        // if (document.activeElement != document.body) document.activeElement.blur();
                                      }
                                    }}
                                  />
                                  <button
                                    type="button"
                                    className="absolute right-[10px] top-1/2 h-[16px] w-[16px] -translate-y-1/2 border-none bg-none text-black"
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                  >
                                    {showPassword ? (
                                      <EyeIcon cls="w-[16px] h-[16px]" />
                                    ) : (
                                      <EyeSlashIcon cls="w-[16px] h-[16px]" />
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div className="flex justify-between text-right">
                              <div>
                                <FieldErrorMessage name="password" />
                              </div>
                              <div>
                                <span
                                  className="authLink inline-block !text-[14px]"
                                  onClick={() => {
                                    dispatch(
                                      updateShowBoxes("forgot_password"),
                                    );
                                  }}
                                >
                                  Forgot password?
                                </span>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="mt-4 flex flex-col gap-3">
                              <label
                                htmlFor="password"
                                className="label !text-[14px]"
                              >
                                New Password <RequiredSymbol />
                              </label>
                              <div>
                                <div className="relative">
                                  <Field
                                    type={showPassword ? "text" : "password"}
                                    className={`h-[40px] w-full rounded-lg border border-bodyText bg-none text-[14px] text-black shadow-none placeholder:text-[14px] placeholder:font-medium placeholder:text-txtColor autofill:bg-none autofill:shadow-none focus:border focus:border-primary focus:shadow-none focus:ring-0 ${
                                      errors.password && touched.password
                                        ? "!border-red-500"
                                        : ""
                                    }`}
                                    autoComplete="off"
                                    name="password"
                                    placeholder="Enter New Password"
                                    validate={(value) =>
                                      validatePassword(value, {
                                        min: 8,
                                        max: 20,
                                        upperCase: true,
                                        lowerCase: true,
                                        number: true,
                                        special: true,
                                      })
                                    }
                                    onKeyUp={(e) => {
                                      if (touched.password && errors.password) {
                                        validateForm();
                                      }
                                      if (e.keyCode === 13) {
                                        submitForm();
                                        if (
                                          document.activeElement !=
                                          document.body
                                        )
                                          document.activeElement.blur();
                                      }
                                    }}
                                  />

                                  <button
                                    type="button"
                                    className="absolute right-[10px] top-1/2 h-[16px] w-[16px] -translate-y-1/2 border-none bg-none text-black"
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                  >
                                    {showPassword ? (
                                      <EyeIcon cls="w-[16px] h-[16px]" />
                                    ) : (
                                      <EyeSlashIcon cls="w-[16px] h-[16px]" />
                                    )}
                                  </button>
                                </div>
                                <FieldErrorMessage name="password" />
                              </div>
                            </div>
                            <div className="mt-4 flex flex-col gap-3">
                              <label
                                htmlFor="password"
                                className="label !text-[14px]"
                              >
                                Confirm New Password <RequiredSymbol />
                              </label>
                              <div>
                                <div className="relative">
                                  <Field
                                    type={
                                      showConfirmPassword ? "text" : "password"
                                    }
                                    className={`h-[40px] w-full rounded-lg border border-bodyText bg-none !text-[14px] text-black shadow-none placeholder:text-[12px] placeholder:font-medium placeholder:text-txtColor autofill:bg-none autofill:shadow-none focus:border focus:border-primary focus:shadow-none focus:ring-0 ${
                                      errors.confirm_password &&
                                      touched.confirm_password
                                        ? "!border-red-500"
                                        : ""
                                    }`}
                                    autoComplete="off"
                                    name="confirm_password"
                                    placeholder="Confirm New Password"
                                    validate={(value) => {
                                      if (!value) {
                                        return "Confirm Password Required";
                                      } else if (value !== values.password) {
                                        return `Password doesn't match`;
                                      }
                                    }}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "confirm_password",
                                        e.target.value,
                                      );
                                      setTimeout(() => {
                                        validateField("confirm_password");
                                      }, 50);
                                    }}
                                    onKeyUp={(e) => {
                                      if (
                                        touched.confirm_password &&
                                        errors.confirm_password
                                      ) {
                                        validateForm();
                                      }
                                      if (e.keyCode === 13) {
                                        submitForm();
                                        if (
                                          document.activeElement !=
                                          document.body
                                        )
                                          document.activeElement.blur();
                                      }
                                    }}
                                  />
                                  <button
                                    type="button"
                                    className="absolute right-[10px] top-1/2 h-[16px] w-[16px] -translate-y-1/2 border-none bg-none text-black"
                                    onClick={() => {
                                      setShowConfirmPassword(
                                        !showConfirmPassword,
                                      );
                                    }}
                                  >
                                    {showConfirmPassword ? (
                                      <EyeIcon />
                                    ) : (
                                      <EyeSlashIcon />
                                    )}
                                  </button>
                                </div>
                                <FieldErrorMessage name="confirm_password" />
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </>
                ) : null}
              </div>
              <AuthButton
                submitForm={submitForm}
                isSubmitting={isSubmitting}
                isValid={isValid}
                btnText={
                  isEmailValidated
                    ? has_agencies == 1 && !selectedAgencyUserId
                      ? "Continue"
                      : hasPassword
                        ? "Sign In"
                        : "Set New Password"
                    : "Continue"
                }
                btnLoadingText={"Signing"}
                disabled={isSubmitting}
              />
            </div>
          </Form>
        )}
      </Formik>
      {/* <SocialMediaIcons /> */}
    </div>
  );
};

export default LoginForm;
